var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgISeeYou(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6089 20.2109C30.5752 21.2277 30.5752 22.7724 29.6089 23.7891C27.9791 25.5039 25.1799 27.8334 22.0003 27.8334C18.8207 27.8334 16.0216 25.5039 14.3917 23.7891C13.4254 22.7724 13.4254 21.2277 14.3917 20.2109C16.0216 18.4961 18.8207 16.1667 22.0003 16.1667C25.1799 16.1667 27.9791 18.4961 29.6089 20.2109Z",
    stroke: "#0085FF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5003 22C24.5003 23.3807 23.381 24.5 22.0003 24.5C20.6196 24.5 19.5003 23.3807 19.5003 22C19.5003 20.6193 20.6196 19.5 22.0003 19.5C23.381 19.5 24.5003 20.6193 24.5003 22Z",
    stroke: "#0085FF",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgISeeYou);
export default __webpack_public_path__ + "static/media/i-see-you.dbccae85317f02982a7d2ff8c819dbfe.svg";
export { ForwardRef as ReactComponent };